import FantasyLabsService from '../../services/fantasyLabsService';
import * as actionTypes from '../../constants/actionTypes';

export function logoutUser(sessionId) {
    return dispatch => {
        dispatch(userDetailFetching());

        const service = new FantasyLabsService();
        service.logoutUser(sessionId, err => dispatch(userDetailFailed(err)), () => dispatch(userDetailSuccess()));
    };
}

function userDetailFetching() {
    return {
        type: actionTypes.LOGOUT_FETCHING
    };
}

function userDetailSuccess() {
    return {
        type: actionTypes.LOGOUT_SUCCESS
    };
}

function userDetailFailed(err) {
    return {
        type: actionTypes.LOGOUT_FAILED,
        errorMessage: err
    };
}



// WEBPACK FOOTER //
// ./src/redux/actions/logout.js